import http from '../utils/http'
import api from '.'

export function gotopay(data) {
    return http.get(api.vip.Company_Pay, data)
}

